export default "__VITE_ASSET__dc1c35f8__"